module.exports = __webpack_public_path__ + "img/id-photo-default.e2bec485.png";